import { api } from '@/services/api/main/axios';

export const postImportSettingsApiRequest = async (
  from: string,
  payload: Record<string, unknown>,
) => {
  const res = await api.post<{ payload: unknown }>(`import/${from}`, payload);
  return res.data.payload;
};
